import React from 'react'
import { Link } from 'react-router-dom';
import logo from 'D:/works/my-portfolio/src/jasmine.png'

let logoStyle=
{
      width: 30,
      height:30,
}
export default function Navbar()
{
  return (
    <div>
      <nav className="navbar navbar-expand-lg">
    <div className="container-fluid">
    <a className='navbar-brand' href='/'><img src={logo} alt="Logo" style={logoStyle}/></a>
    <a className="navbar-brand text-white" href="/">Jesmine's</a>
    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span className="navbar-toggler-icon"></span>
    </button>
    <div className="collapse navbar-collapse" id="navbarSupportedContent">
      <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
        <li className="nav-item">
          <Link className="nav-link text-white" aria-current="page" to="/home">Home</Link>
        </li>
        <li className="nav-item">
          <Link className="nav-link text-white" to="/work">Work</Link>
        </li>
        <li className="nav-item">
          <Link className="nav-link text-white" to="/contact">Contact</Link>
        </li>
      </ul>
      <ul className="navbar-nav d-flex flex-row me-1">
                <li className="nav-item me-3 me-lg-0">
                    <a className="nav-link text-white" href="https://www.linkedin.com/in/jesmine-akhter-3ab991247" title="Let us connect on Linkedin" target="_blank"><i className="fab fa-linkedin"></i></a>
                </li>
                <li className="nav-item me-3 me-lg-0">
                    <a className="nav-link text-white" href="https://www.behance.net/jesmine_akhter" title="See me on Behance" target="_blank"><i className="fab fa-behance"></i></a>
                </li>
                <li className="nav-item me-3 me-lg-0">
                    <a className="nav-link text-white" href="https://github.com/JA-26-01" title="My Github Profile" target="_blank"><i className="fab fa-github"></i></a>
                </li>
       </ul>
    </div>
  </div>
</nav>
    </div>
  )
}
